module.exports = __webpack_public_path__ + "static/media/upload.14c2134c.svg";